import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MethodResponse, PagedModel } from 'app/models/base-models';
import { SystemJob } from 'app/models/system-jobs/system-job';
import { SystemJobDetails } from 'app/models/system-jobs/system-job-details';
import { SystemJobListFilter } from 'app/models/system-jobs/system-job-filter';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SystemJobService {
    constructor(private http: HttpClient) {}
    systemJobs$ = new BehaviorSubject<SystemJob[]>([]); // array

    getPaginatedSystemJobs(
        page: number,
        pageSize: number,
        sortKey: string,
        sortOrder: string,
        filters: SystemJobListFilter
    ): Observable<PagedModel> {
        let httpParams = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString())
            .set('sortKey', sortKey) 
            .set('sortOrder', sortOrder);

        if (filters.fromDate) {
            httpParams = httpParams.set('fromDate', filters.fromDate);
        }
        if (filters.toDate) {
            httpParams = httpParams.set('toDate', filters.toDate);
        }
        if (filters.id) {
            httpParams = httpParams.set('id', filters.id);
        }
        if (filters.jobType) {
            httpParams = httpParams.set('jobTypeId', filters.jobType);
        }
        if (filters.status) {
            httpParams = httpParams.set('status', filters.status.trim());
        }

        return this.http
            .get(`${environment.apiUrl}/system-jobs?`, {
                params: httpParams,
            })
            .pipe(
                map((res) => {
                    return new PagedModel(
                        res['firstItemOnPage'],
                        res['lastItemOnPage'],
                        res['totalItemCount'],
                        res['items']
                    );
                })
            );
    }

    rerunSystemJob(id: number): Observable<MethodResponse> {
        let params = new HttpParams()
            .set('id', id);

        return this.http
            .post<MethodResponse>(`${environment.apiUrl}/system-jobs/rerun`,
                {},
                { params }
            );
    }

    getFailedSystemJobsCount(): Observable<string> {
        return this.http
            .get<string>(
                `${environment.apiUrl}/system-jobs/count-failed`
            )
            .pipe(map((res) => res));
    }
}
